import CheckFilled from "./SVG/check-filled.svg?react";

const CheckFilledIcon = ({ title }: { title?: string }) => {
  return <CheckFilled title={title} />;
};

export default CheckFilledIcon;
